import PropTypes from 'prop-types'

const SpaceLandingLinks = ({ children }: any) => <ul className="space-page-landing-docs-links">{children}</ul>

SpaceLandingLinks.displayName = 'SpaceLandingLinks'

SpaceLandingLinks.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.object)])
}

SpaceLandingLinks.defaultProps = {
  children: null
}

export default SpaceLandingLinks
